import {css} from 'lit'; export default css`.hotkey-shortcut-keys-input{min-width:180px;caret-color:transparent}.clear-key-combination-button{cursor:pointer}.input-left-space{margin-left:5px}`;
    